import { defineComponent as we, useAttrs as pe, ref as f, computed as n, onMounted as he, onUnmounted as ve, watch as P, provide as ye, reactive as be, openBlock as o, createElementBlock as d, Fragment as w, normalizeStyle as j, renderList as y, toDisplayString as D, createCommentVNode as b, createElementVNode as k, mergeProps as O, normalizeClass as F, renderSlot as T, createBlock as c, withCtx as p, createVNode as G, unref as U, createTextVNode as B } from "vue";
import { Size as E, Variant as Re, getTableContainerStyleClasses as ge, getTableStyleClasses as Se, getTableHeadStyleClasses as Ae, SelectAllState as S, SortState as u, TableBodyRowPropsSymbol as Ce } from "./novoui-vuejs76.js";
import X from "./novoui-vuejs45.js";
import _ from "./novoui-vuejs44.js";
import $ from "./novoui-vuejs43.js";
import ke from "./novoui-vuejs30.js";
const Te = {
  key: 0,
  class: "table-head"
}, Xe = /* @__PURE__ */ we({
  inheritAttrs: !1,
  __name: "NTable",
  props: {
    bodyRowSize: { default: E.md },
    columnBorder: { type: Boolean, default: !1 },
    containerCssClass: { default: void 0 },
    containerHeight: { default: void 0 },
    expandableRow: { type: Boolean, default: !1 },
    headers: { default: () => [] },
    headRowSize: { default: E.lg },
    items: { default: () => [] },
    loadXMoreRowsAtATime: { default: -1 },
    resizableColumns: { type: Boolean, default: !1 },
    rowKey: {},
    selectableRow: { type: Boolean, default: !1 },
    selectedRowIds: { default: () => [] },
    stickyHeader: { type: Boolean, default: !0 },
    variant: { default: Re.light },
    disableExpandAnimations: { type: Boolean, default: !1 }
  },
  emits: ["update:selectedRowIdsSet", "update:sorting", "update:load-more-rows", "update:scroll-position"],
  setup(q, { emit: J }) {
    const h = J, e = q, { class: Q, ...Y } = pe(), I = f("auto");
    function z() {
      A.value.children && Array.from(A.value.children).length > 0 && (I.value = Array.from(A.value.children).map((t) => `${t.clientWidth}px`).join(" "));
    }
    function Z(t) {
      const l = e.headers.indexOf(t) + 1;
      return e.selectableRow || e.expandableRow ? l + 1 : l;
    }
    const v = f(), L = f(!1), A = f(), N = n(
      () => typeof e.loadXMoreRowsAtATime == "number" ? e.loadXMoreRowsAtATime : e.items.length === 0 ? e.loadXMoreRowsAtATime.initialLoad || e.loadXMoreRowsAtATime.limitSkeletonRows || e.loadXMoreRowsAtATime.rowsLoadedAtATime : e.loadXMoreRowsAtATime.limitSkeletonRows || e.loadXMoreRowsAtATime.rowsLoadedAtATime
    ), x = e.bodyRowSize === E.md ? 48 : 64, ee = n(() => ge(L.value, e)), te = n(() => Se(e, Q)), ae = n(() => Ae(e));
    he(() => {
      v.value.addEventListener("scroll", V), v.value.scrollHeight > v.value.clientHeight && window.navigator.userAgent.includes("Windows") && (L.value = !0);
    }), ve(() => {
      v.value && v.value.removeEventListener("scroll", V);
    });
    const K = f(!1);
    P(
      () => e.items,
      (t, l) => {
        K.value = !1;
      }
    );
    function V(t) {
      const l = t.target;
      h("update:scroll-position", l.scrollTop);
      let a;
      typeof e.loadXMoreRowsAtATime == "number" ? a = e.loadXMoreRowsAtATime : a = e.loadXMoreRowsAtATime.limitSkeletonRows || e.loadXMoreRowsAtATime.rowsLoadedAtATime, !K.value && l.scrollTop + l.clientHeight >= l.scrollHeight - (a - 0.5) * x && (K.value = !0, h("update:load-more-rows", t));
    }
    const r = f(/* @__PURE__ */ new Set());
    P(
      () => e.selectedRowIds,
      (t) => {
        r.value = new Set(t);
      },
      { immediate: !0 }
    );
    const W = n(() => r.value.size === 0 ? S.none : r.value.size === e.items.length ? S.all : S.partial), le = () => {
      r.value.size !== e.items.length && (e.items.forEach((t, l) => {
        R.value.has(e.rowKey ? t[e.rowKey] : l) || r.value.add(e.rowKey ? t[e.rowKey] : l);
      }), h("update:selectedRowIdsSet", Array.from(r.value)));
    }, oe = () => {
      r.value.size !== 0 && (e.items.forEach((t, l) => {
        R.value.has(e.rowKey ? t[e.rowKey] : l) || r.value.delete(e.rowKey ? t[e.rowKey] : l);
      }), h("update:selectedRowIdsSet", Array.from(r.value)));
    }, se = (t) => {
      t && (r.value.has(t) ? r.value.delete(t) : r.value.add(t), h("update:selectedRowIdsSet", Array.from(r.value)));
    }, R = f(/* @__PURE__ */ new Set()), re = (t) => {
      t && (R.value.has(t) ? R.value.delete(t) : R.value.add(t));
    }, i = f(
      new Map(e.headers.map((t) => [t.key, t.initialSortState ? t.initialSortState : u.none]))
    ), ne = (t, l) => {
      var s, m;
      if (!l || ((s = e.headers.find((g) => g.key === l)) == null ? void 0 : s.isSortable) === void 0 || ((m = e.headers.find((g) => g.key === l)) == null ? void 0 : m.isSortable) === !1)
        return;
      const a = i.value.get(l);
      a === u.none ? (i.value.forEach((g, H) => i.value.set(H, u.none)), i.value.set(l, u.asc)) : a === u.asc ? (i.value.forEach((g, H) => i.value.set(H, u.none)), i.value.set(l, u.desc)) : a === u.desc && i.value.set(l, u.none), h("update:sorting", i.value);
    };
    function C(t) {
      return e.headers && e.headers.length > 0 ? t.key : t;
    }
    const M = n(() => e.headers && e.headers.length > 0 ? e.headers : Object.keys(e.items[0])), ie = n(() => e.selectableRow), de = n(() => Array.from(r.value)), ue = n(() => e.expandableRow), me = n(() => e.bodyRowSize), fe = n(() => e.resizableColumns), ce = n(() => e.disableExpandAnimations);
    return ye(
      Ce,
      be({
        selectedRowIdsSetRef: de,
        selectableRowRef: ie,
        selectRow: se,
        updateDisabledRow: re,
        expandableRowRef: ue,
        bodySizeRef: me,
        resizableColumnsRef: fe,
        disableExpandAnimationsRef: ce
      })
    ), (t, l) => (o(), d(w, null, [
      t.headers && t.headers.some((a) => {
        var s;
        return (s = a.prependedContent) == null ? void 0 : s.trim();
      }) ? (o(), d("div", {
        key: 0,
        class: "table-prepended-container",
        style: j({ display: "grid", gridTemplateColumns: I.value })
      }, [
        (o(!0), d(w, null, y(t.headers.filter((a) => {
          var s;
          return (s = a.prependedContent) == null ? void 0 : s.trim();
        }), (a) => (o(), d("div", {
          key: a.key,
          class: "table-prepended-head",
          style: j({ gridColumn: Z(a) })
        }, D(a.prependedContent), 5))), 128))
      ], 4)) : b("", !0),
      k("div", O(Y, {
        ref_key: "tableContainerRef",
        ref: v,
        class: ee.value,
        style: { maxHeight: t.containerHeight ? t.containerHeight : "unset" }
      }), [
        k("table", {
          class: F(te.value)
        }, [
          e.headers && e.headers.length > 0 ? (o(), d("thead", Te, [
            T(t.$slots, "pre-head"),
            T(t.$slots, "head", {}, () => [
              k("tr", {
                ref_key: "headsRow",
                ref: A,
                class: F(ae.value)
              }, [
                t.selectableRow ? (o(), c(X, {
                  key: 0,
                  action: !0,
                  "is-not-resizable": !0,
                  onColumnWidth: z
                }, {
                  default: p(() => [
                    G(ke, {
                      "model-value": W.value === U(S).all,
                      indeterminate: W.value === U(S).partial,
                      onChange: l[0] || (l[0] = (a) => a.target.checked ? le() : oe()),
                      "aria-label": "select-all-rows"
                    }, null, 8, ["model-value", "indeterminate"])
                  ]),
                  _: 1
                })) : b("", !0),
                t.expandableRow ? (o(), c(X, {
                  key: 1,
                  action: !0,
                  "is-not-resizable": !0,
                  onColumnWidth: z
                }, {
                  default: p(() => [
                    B(" ")
                  ]),
                  _: 1
                })) : b("", !0),
                (o(!0), d(w, null, y(t.headers, (a, s) => (o(), c(X, {
                  key: a.key,
                  header: a.header,
                  subheader: a.subHeader,
                  tooltipContent: a.tooltipContent,
                  sortable: a.isSortable,
                  sortState: i.value.get(a.key),
                  headVariant: e.variant,
                  alignment: a.alignment,
                  "is-not-resizable": s === t.headers.length - 1 || !t.columnBorder || !t.resizableColumns || t.selectableRow || t.expandableRow,
                  onClick: (m) => ne(m, a.key),
                  onColumnWidth: z
                }, null, 8, ["header", "subheader", "tooltipContent", "sortable", "sortState", "headVariant", "alignment", "is-not-resizable", "onClick"]))), 128))
              ], 2)
            ])
          ])) : b("", !0),
          k("tbody", null, [
            !e.items || e.items.length === 0 ? (o(), c($, {
              key: 0,
              rowId: "empty_row",
              class: "table-body-row-empty"
            }, {
              default: p(() => [
                G(_, {
                  colspan: M.value.length
                }, {
                  default: p(() => [
                    B("No data to display")
                  ]),
                  _: 1
                }, 8, ["colspan"])
              ]),
              _: 1
            })) : b("", !0),
            T(t.$slots, "body", { items: t.items }, () => [
              (o(!0), d(w, null, y(e.items, (a, s) => (o(), c($, {
                key: e.rowKey ? a[e.rowKey] : s,
                rowId: e.rowKey ? a[e.rowKey] : s
              }, {
                default: p(() => [
                  (o(!0), d(w, null, y(M.value, (m) => (o(), c(_, {
                    key: C(m)
                  }, {
                    default: p(() => [
                      T(t.$slots, `item.${String(C(m))}`, O({ ref_for: !0 }, { item: a }), () => [
                        B(D(a[String(C(m))]), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))), 128))
                ]),
                _: 2
              }, 1032, ["rowId"]))), 128))
            ]),
            N.value > -1 ? (o(!0), d(w, { key: 1 }, y(N.value, (a) => (o(), c($, {
              key: `loading_row_${a}`,
              rowId: `loading_row_${a}`
            }, {
              default: p(() => [
                (o(!0), d(w, null, y(M.value, (s) => (o(), c(_, {
                  loading: !0,
                  key: `loading_${String(C(s))}`
                }))), 128))
              ]),
              _: 2
            }, 1032, ["rowId"]))), 128)) : b("", !0)
          ])
        ], 2)
      ], 16)
    ], 64));
  }
});
export {
  Xe as default
};
